import React from "react";
import Marquee from "react-fast-marquee";

const clients = [
  "The Indian Public School",
  "CS Academy",
  "Sancta Maria International School",
  "Manthan School",
  "Isthara",
];

const Separator = () => (
  <span className="mx-10 lg:mx-16 inline-flex items-center">
    <span className="block w-3 h-3 bg-[#0038FF] rotate-45" />
  </span>
);

const Clients = () => {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="py-20 lg:py-28 bg-white border-y border-[#e5e5e5]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 lg:mb-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="font-mono text-xs text-[#0038FF]">[ 06 ]</span>
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#0038FF]">
                Our Clientele
              </span>
            </div>
            <h2
              data-testid="clients-heading"
              className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl font-black tracking-tighter text-[#0a0a0a] break-words"
            >
              Trusted by operators
              <br />
              who don&apos;t do average.
            </h2>
          </div>
          <p className="text-base text-[#4a4a4a] max-w-md leading-relaxed">
            A growing roster of leading schools and food-tech pioneers across
            India who run mission-critical operations on systems we build and
            steward.
          </p>
        </div>
      </div>

      <div className="marquee-fade overflow-hidden">
        <Marquee
          speed={42}
          gradient={false}
          pauseOnHover
          data-testid="clients-marquee"
        >
          {[...clients, ...clients].map((c, idx) => (
            <span
              key={`${c}-${idx}`}
              data-testid={`client-name-${idx}`}
              className="font-display text-3xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-[#0a0a0a] uppercase inline-flex items-center"
            >
              {c}
              <Separator />
            </span>
          ))}
        </Marquee>
      </div>

      {/* Static grid for accessibility / fallback */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 grid grid-cols-2 md:grid-cols-5 gap-px bg-[#e5e5e5] border border-[#e5e5e5]">
        {clients.map((c, idx) => (
          <div
            key={c}
            data-testid={`client-card-${idx}`}
            className="bg-white p-6 lg:p-8 min-h-[120px] flex items-center justify-center text-center hover:bg-[#0a0a0a] hover:text-white transition-colors duration-300 group"
          >
            <span className="font-display text-base lg:text-lg font-bold tracking-tight text-[#0a0a0a] group-hover:text-white">
              {c}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Clients;
